import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LoadingButton,
} from '@cmg/design-system';
import React from 'react';

export type PassIndicationDialogProps = {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onPass: () => void;
};

export const PassIndicationDialog: React.FC<PassIndicationDialogProps> = ({
  isOpen,
  isLoading,
  onPass,
  onClose,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Pass on Offering</DialogTitle>

      <DialogContent dividers>Are you sure you want to pass on this offering?</DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={isLoading}>
          Close
        </Button>
        <LoadingButton variant="contained" onClick={onPass} loading={isLoading}>
          Continue
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
